module.exports = __webpack_public_path__ + "7b2a7606.svg";